module.exports = __webpack_public_path__ + "static/media/USWeekly.e89743b3.png";